import { LogRocketController } from '../ui_log_rocket/LogRocketController.ts';
import { isCrawler } from './BotAnalytics.ts';
import { UIAPIEndpoints } from '../network/UIAPIEndpoints.ts';
import { UIAjaxWrapper } from '../network/UIAjaxWrapper.ts';
import { UIUtilsEjsVariables } from '../UIUtilsEjsVariables.ts';
import { UISessionRecorder } from '../ui_session_recorder/UISessionRecorder.ts';
import { uiGameManager } from '../EntryShared.ts';
import { UIDeviceController } from '../ui_html/UIDeviceController.ts';
(function(CA) {
    (function(GoogleTagManagerEvent) {
        GoogleTagManagerEvent["GameStarted"] = "game_started";
        GoogleTagManagerEvent["GameFinished"] = "game_finished";
        GoogleTagManagerEvent["UserClickedLoginButton"] = "user_clicked_login";
        GoogleTagManagerEvent["PurchaseCompleted"] = "purchase_completed";
    })(CA.GoogleTagManagerEvent || (CA.GoogleTagManagerEvent = {}));
    const internalSingleOccurrenceEvents = new Map();
    const internalUniqueEvents = new Set();
    const sessionInitTime = Date.now().valueOf();
    async function initLogRocket() {
        CA.logRocket = new LogRocketController();
        await CA.logRocket.init();
    }
    CA.initLogRocket = initLogRocket;
    function initializeSessionRecorder() {
        CA.sessionRecorder = new UISessionRecorder();
    }
    CA.initializeSessionRecorder = initializeSessionRecorder;
    async function sendAnalyticEvent(data) {
        if (!UIUtilsEjsVariables.analyticsActive) return;
        if (isCrawler()) return;
        await UIAjaxWrapper.postRequestWhenReady(UIAPIEndpoints.apiAnalytics(), data, undefined);
    }
    CA.sendAnalyticEvent = sendAnalyticEvent;
    async function sendAnalyticEventsWithMobileDimensions(data) {
        var _uiGameManager_gameController_gameSettings, _uiGameManager_gameController, _uiGameManager_gameController_gameSettings1, _uiGameManager_gameController1;
        if (!UIUtilsEjsVariables.analyticsActive) return;
        if (isCrawler()) return;
        const dimensions = {
            isApp: UIUtilsEjsVariables.isUserOnMobileAppOrWeb,
            isTablet: UIDeviceController.isUserOnTabletApp(),
            isAndroid: navigator.userAgent.includes('Android'),
            isPortrait: UIUtilsEjsVariables.shouldDisplayNewMobileGameUI,
            gameType: uiGameManager === null || uiGameManager === void 0 ? void 0 : (_uiGameManager_gameController = uiGameManager.gameController) === null || _uiGameManager_gameController === void 0 ? void 0 : (_uiGameManager_gameController_gameSettings = _uiGameManager_gameController.gameSettings) === null || _uiGameManager_gameController_gameSettings === void 0 ? void 0 : _uiGameManager_gameController_gameSettings.gameType,
            eloType: uiGameManager === null || uiGameManager === void 0 ? void 0 : (_uiGameManager_gameController1 = uiGameManager.gameController) === null || _uiGameManager_gameController1 === void 0 ? void 0 : (_uiGameManager_gameController_gameSettings1 = _uiGameManager_gameController1.gameSettings) === null || _uiGameManager_gameController_gameSettings1 === void 0 ? void 0 : _uiGameManager_gameController_gameSettings1.eloType,
            ...data.dimensions
        };
        await sendAnalyticEvent({
            ...data,
            dimensions: dimensions
        });
    }
    CA.sendAnalyticEventsWithMobileDimensions = sendAnalyticEventsWithMobileDimensions;
    async function sendAnalyticEventOnce(data) {
        if (data.floatValue == undefined && internalSingleOccurrenceEvents.has(data.type)) return;
        if (!internalSingleOccurrenceEvents.has(data.type)) internalSingleOccurrenceEvents.set(data.type, new Set());
        if (data.floatValue == undefined) return sendAnalyticEvent(data);
        const existingFloatValues = internalSingleOccurrenceEvents.get(data.type);
        if (existingFloatValues === null || existingFloatValues === void 0 ? void 0 : existingFloatValues.has(data.floatValue)) return;
        existingFloatValues === null || existingFloatValues === void 0 ? void 0 : existingFloatValues.add(data.floatValue);
        return sendAnalyticEvent(data);
    }
    CA.sendAnalyticEventOnce = sendAnalyticEventOnce;
    async function sendTimedAnalyticEventOnce(data) {
        const uniqueEventId = `${data.type}_${data.stringValue || ''}`;
        if (internalUniqueEvents.has(uniqueEventId)) return;
        internalUniqueEvents.add(uniqueEventId);
        const currentTime = Date.now().valueOf();
        data.floatValue = (currentTime - sessionInitTime) / 1000;
        return sendAnalyticEvent(data);
    }
    CA.sendTimedAnalyticEventOnce = sendTimedAnalyticEventOnce;
    function sendGoogleTagManagerEvent(event) {
        var _window_dataLayer;
        if (!UIUtilsEjsVariables.analyticsActive) return;
        if (UIUtilsEjsVariables.isUserOnDiscord) return;
        if (isCrawler()) return;
        (_window_dataLayer = window.dataLayer) === null || _window_dataLayer === void 0 ? void 0 : _window_dataLayer.push({
            event: event
        });
    }
    CA.sendGoogleTagManagerEvent = sendGoogleTagManagerEvent;
})(CA || (CA = {}));
export var CA;
